import { SentryTraced } from "@sentry/nestjs"
import { z } from "zod"

import { VaultService } from "../services/index.js"
import { commonFlags, getTargetEnv, SentryCommand } from "../types/index.js"

export default class Logout extends SentryCommand<object> {
  static override args = {}
  static override description = "Logout from the Supernova"
  static override examples = ["<%= config.bin %> <%= command.id %>"]
  static override flags = commonFlags
  private vaultService = new VaultService()

  get commandId(): string {
    return Logout.id
  }

  get configSchema() {
    return z.object({})
  }

  @SentryTraced()
  public async run(): Promise<void> {
    await this.vaultService.deleteTokensFromVault(getTargetEnv())
    this.log("You have been logged out")
  }
}
